import * as React from 'react';

import { Link } from 'react-router-dom';

import * as Const from '../../constants';

import UserInfo from '../../interfaces/UserInfo';

interface Props {
  tableHeadItem: string;
  firstUserInfoItem: UserInfo;
}

function PersonalArea (props: Props) {

  const {
    tableHeadItem,
    firstUserInfoItem,
  } = props;

  return (
    <div className='d-flex border-row'>
      <div className='personal-title bold'>
        {tableHeadItem[0].toUpperCase() + tableHeadItem.slice(1).split('_').join(' ')}
      </div>
      <div className='personal-text'>
        <Link to={`/map?id=${firstUserInfoItem[Const.PERSONAL_USER_ID]}`} >{firstUserInfoItem[tableHeadItem]} </Link>
      </div>
    </div>
  );
}

export default React.memo(PersonalArea);
